import React from 'react';
import styles from './UpdateFile.module.scss';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { useDispatch, useSelector } from 'react-redux';
import { setVisibleModal } from '../../../../store/actions/actions';
import { Button, Tooltip } from 'antd';

const UpdateFile = ({ file }) => {
  const dispatch = useDispatch();

  const { openedFile, listLoading } = useSelector((store) => store.debtsStore);

  const noticesAmount = openedFile?.notices?.length;

  const handleClick = () => {
    dispatch(setVisibleModal({ visible: true, value: file }));
  };

  return (
    <>
      {!!noticesAmount || listLoading ? (
        <Tooltip title="Загрузка не может быть обновлена, т.к. было запущено оповещение о задолженности">
          <Button
            type="primary"
            onClick={handleClick}
            disabled={!!noticesAmount}
          >
            Обновить загрузку
          </Button>
        </Tooltip>
      ) : (
        <RoundedButton
          className={styles.root}
          text="Обновить загрузку"
          onClick={handleClick}
        />
      )}
    </>
  );
};

export default UpdateFile;
